<template>
    <div class="tooltip-base" ref="base">

        <slot></slot>

        <div
            class="tooltip"
            :class="{ 'inactive': ! isOpen, 'active': isOpen }, size"
            :data-reference="reference"
            v-html="text"
        ></div>
    </div>
</template>

<script>

export default {

    name: 'ToolTip',

    props: ['reference', 'text', 'size'],

    data() {
        return {
            toolTipTarget: null,
            target: false,
            isOpen: false,
        }
    },

    created() {
    },

    mounted() {

        this.Bus.on('toggle-tooltip', (reference) => {
            console.log('toggle-tooltip');
            console.log(reference);
            console.log(this.reference);
            if (reference === this.reference) {
                this.toggle()
            }
        });

        document.addEventListener('click', this.handleClickOutside);
    },

    beforeUnmount() {
        // Remove event listener when component is unmounted
        document.removeEventListener('click', this.handleClickOutside);
    },

    methods: {

        handleClickOutside(event) {
            if (this.isOpen && event.target.closest('.tooltip-base') !== this.$refs.base) {
                this.isOpen = false;
            }
        },

        toggle() {
            this.isOpen = ! this.isOpen;
        },
    },

    render() {

    },
};
</script>
